import React from 'react'
import {Modal} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {Form} from 'react-form'
import validateLogin from '../../../utils/validateLogin'
import LoginForm from './LoginForm.js'
import showToastr from '../../../utils/showToastr'
import ErrorHandler from '../../../utils/ErrorHandler'

import './Layout/LoginBox.css'

class LoginBox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: {type: '', context: ''},
      isLoading: false
    }
  }
  render () {
    const {message, isLoading} = this.state
    return (
      <Modal show={this.props.isVisible} onHide={() => Actions.toggleLoginBox(false)} aria-labelledby="contained-modal-title-sm">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-sm">لازم است به سایت وارد شوید</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
          <Form
            validate={validateLogin}
            ref="loginForm"
            disable={isLoading}
            onSubmit={(values) => {
              Actions.login(values).then((res) => {
                showToastr('success', 'ورود', 'با موفقیت وارد شدید')
                Actions.userInfo()
                Actions.toggleLoginBox(false)
                this.setState({isLoading: false})
              }).catch((err) => {
                let eh = new ErrorHandler(err)
                this.setState({message: eh.message, isLoading: false})
                eh.setFormErrors(this.refs.loginForm)
                eh.showToastrIn('ورود')
              })
            }}>
            {LoginForm}
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isVisible: state.auth.isLoginBoxVisible
  }
}

export default connect(mapStateToProps)(LoginBox)



// WEBPACK FOOTER //
// ./src/components/Common/LoginBox/LoginBox.js